module.exports = __webpack_public_path__ + "static/media/cube.712387ca.svg";